import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const MissalLazy = createLazyComponent(() => import('./Missal'))

const Missal = (props) => <MissalLazy {...props} />

export default Missal
